import {
  Laptop2,
  Wifi,
  Tv,
  ShieldAlert,
  Smartphone,
  Briefcase,
} from "lucide-react";

const SERVICES = [
  {
    icon: Laptop2,
    title: "Computer & Laptop Repair",
    desc: "Slow, frozen, or broken? I'll diagnose the issue, replace what's needed, and get you back up and running.",
    testid: "service-computer-repair",
  },
  {
    icon: Wifi,
    title: "Wi-Fi & Home Network Setup",
    desc: "Strong, reliable Wi-Fi in every room. Modems, mesh systems, and dead-spot fixes — all explained simply.",
    testid: "service-wifi-network",
  },
  {
    icon: Tv,
    title: "Smart TV & Device Setup",
    desc: "Streaming, casting, smart speakers, lights, cameras — get every device talking the way you want it to.",
    testid: "service-smart-home",
  },
  {
    icon: ShieldAlert,
    title: "Virus & Malware Removal",
    desc: "Pop-ups, scams, slow performance? I'll clean it up, lock it down, and show you how to stay safe online.",
    testid: "service-virus-removal",
  },
  {
    icon: Smartphone,
    title: "Phone & Tablet Support",
    desc: "Email, photos, backups, apps and account help on iPhone, iPad, Android — patient teaching included.",
    testid: "service-phone-tablet",
  },
  {
    icon: Briefcase,
    title: "Small Business IT",
    desc: "Computers, printers, email, cloud storage and backups. Friendly local IT support for small teams.",
    testid: "service-business-it",
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="py-20 sm:py-24">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-2xl">
          <p className="text-sm uppercase tracking-[0.18em] font-semibold text-[#D97706]">
            What I can help with
          </p>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
            Tech help for the whole family — and your business too.
          </h2>
          <p className="mt-4 text-lg text-slate-700">
            If it's got a screen, a plug, or a Wi-Fi connection, chances are I can help.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {SERVICES.map((s) => {
            const Icon = s.icon;
            return (
              <div
                key={s.title}
                data-testid={s.testid}
                className="group bg-white border border-slate-200 rounded-2xl p-8 sm:p-9 shadow-sm hover:shadow-lg hover:-translate-y-1 hover:border-[#1E56B8] transition-all duration-300"
              >
                <div className="w-14 h-14 rounded-xl bg-[#1E56B8]/10 text-[#1E56B8] flex items-center justify-center group-hover:bg-[#1E56B8] group-hover:text-white transition-colors">
                  <Icon className="w-7 h-7" strokeWidth={2} />
                </div>
                <h3 className="mt-6 text-xl font-semibold text-slate-900 font-[Outfit]">
                  {s.title}
                </h3>
                <p className="mt-3 text-base text-slate-700 leading-relaxed">
                  {s.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
